import http from "@/utils/http";

const serverUrl = process.env.VUE_APP_API_TEMPLATE_SERVER_URL;
export default {
    /**
     * 分页查询打印导出日志
     * @param query
     * @returns {*}
     */
    findPrintLogList(query) {
        return http.get("/system/printExport/page", query);
    },
    /**
     *单条查询打印导出日志详情
     * @param params
     * @returns {*}
     */
    getPrintLogOne(params) {
        return http.get("/system/printExport/one", params);
    },
    /**
     *新增打印导出日志
     * @param params
     * @returns {*}
     */
    addPrintLog(params) {
        return http.post("/system/printExport/add", params);
    },

    /**
     *  导出学员信息 20240418
     */
    exportOneStudentInfo(params) {
        return http.post(`/student/export/info`, params);
    },
    /**
     *  导出学员详情 - 弃用
     */
    exportStudentDetailExport(params) {
        return http.post(`${serverUrl}/api/export/student/detail/report`, params);
    },
    /**
     *  导出学员计划详情(导出两类人员进度详情) lzb 20240418
     */
    exportStudentPlanDetailExport(params) {
        return http.post(`/export/towTypePerson/progress/detail`, params);
    },

    /**
     *  导出学员计划流水详情（导出两类人员流水详情）
     */
    exportStudentFlowPlanDetailExport(params) {
        return http.post(`/export/towTypePerson/flow/detail`, params);
    },
    /**
     *  导出学员计划详情 - 保留 - 弃用20251201
     */
    exportStudentPlanDetailOldExport(params) {
        return http.post(`${serverUrl}/export/student/plan/detail`, params);
    },
    /**
     *  导出学员计划详情 -  UZ00141新增的接口 20251201
     */
    exportProgressDetailByStudentPlanDetail(params) {
        return http.post(`/export/progress/detail`, params);
    },
    /**
     *  导出学员流水详情- 保留-弃用20251127
     */
    exportStudentFlowPlanDetailOldExport(params) {
        return http.post(`${serverUrl}/export/student/planFlow/detail`, params);
    },
    /**
     *  导出学员流水详情- UZ00141新增的接口 20251127
     */
    exportFlowDetail(params) {
        return http.post(`/export/flow/detail`, params);
    },
    /**
     *  导出计划详情(两类人员详情)
     */
    exportPlanDetailExport(params) {
        return http.get(`/export/twoTypePerson/plan/detail`, params);
    },

    /**
     *  导出计划详情(监管计划详情)
     */
    exportRegulatoryPlanDetail(params) {
        return http.post(`/export/regulatoryPlan/detail`, params);
    },
    /**
     *  导出计划详情(监管计划详情) - 弃用U-Z00141 20251201 lzb
     */
    exportPlanDetailOldExport(params) {
        return http.post(`${serverUrl}/export/plan/detail`, params);
    },
    /**
     *  导出会议详情 - 弃用
     */
    exportMeetingDetailExport(params) {
        return http.post(`${serverUrl}/export/meeting/detail`, params);
    },
    /**
     *  导出考试详情 - 保留旧版  - 弃用U-Z00141 20251201 lzb
     */
    exportExamDetailExport(params) {
        return http.post(`${serverUrl}/export/exam/detail`, params);
    },
    /**
     * 获取打印列表属性v2版本
     */
    getPrintFields(params) {
        return http.get("/statistics/print/field/v2", params);
    },
    /**
     * v1.0.28 - 个人会议详情的导出 - 弃用
     */
    exportPersonalMeetingDetail(params) {
        return http.post(`${serverUrl}/export/personal/meeting/detail`, params);
    },
    /**
     * 个人会议记录详情的导出
     */
    exportPersonalMeetingRecordDetail(params) {
        return http.post(`${serverUrl}/export/personal/meeting/record/detail`, params);
    },
};
